<template>
  <div class="panel-list-page">
    <div class="pl-card">
      <div class="pl-card__header">
        <div class="pl-card__title-wrap">
          <span class="pl-card__icon" aria-hidden="true">
            <CIcon name="navProducts"/>
          </span>
          <div>
            <h1 class="pl-card__title">برچسب محصولات</h1>
            <p class="pl-card__sub">ویرایش عنوان برچسب‌های ثبت‌شده</p>
          </div>
        </div>
      </div>

      <div class="pl-card__body">
        <CDataTableFixed
          class="pl-table"
          :items="items_tags"
          :fields="fields"
          :items-per-page="20"
          hover
          sorter
          pagination
          :noItemsView="{ noItems: 'برچسبی یافت نشد' }"
        >
          <template #no-items-view>
            <div class="pl-empty">
              <span class="pl-empty__icon" aria-hidden="true">
                <CIcon name="navProducts"/>
              </span>
              <p class="pl-empty__title">برچسبی یافت نشد</p>
              <p class="pl-empty__sub">هنوز برچسبی برای نمایش وجود ندارد.</p>
            </div>
          </template>

          <template #row="{ item }">
            <td>
              <span class="pl-muted">{{ item.row_id + 1 }}</span>
            </td>
          </template>

          <template #name="{ item }">
            <td>
              <span class="pl-name">{{ item.name }}</span>
            </td>
          </template>

          <template #count="{ item }">
            <td>
              <span class="pl-muted">{{ item.count }}</span>
            </td>
          </template>

          <template #operation="{ item }">
            <td class="pl-ops-cell">
              <div class="pl-ops">
                <button type="button" class="pl-icon-btn pl-icon-btn--warn" title="ویرایش برچسب" @click="openEditModal(item)">
                  <CIcon name="iconEdit"/>
                </button>
              </div>
            </td>
          </template>
        </CDataTableFixed>
      </div>
    </div>

    <CModal
      :show.sync="form_modal"
      :centered="true"
      size="md"
      title="ویرایش برچسب"
      @update:show="onFormModalToggle"
    >
      <div class="pl-form">
        <CRow>
          <CCol col="12">
            <CInput
              v-model="name"
              label="نام"
              placeholder="نام برچسب"
            />
          </CCol>
        </CRow>
      </div>
      <template #footer>
        <button type="button" class="pl-btn pl-btn--ghost" @click="closeFormModal()">انصراف</button>
        <button type="button" class="pl-btn pl-btn--primary" @click="edit()">
          <CIcon name="iconCheck"/>
          <span>ذخیره تغییرات</span>
        </button>
      </template>
    </CModal>
  </div>
</template>

<script>
    import axios from "@/api/http";
    var items_tags = [

    ];


    const fields = [
      {key: 'row', label: '#', _style: 'width:10%'},
      {key: 'name', label: 'نام', _style: 'width:30%'},
      {key: 'count', label: 'تعداد', _style: 'width:15%'},
      {key: 'operation', label: 'عملیات', _style: 'width:15%'},
    ];


    export default {
        name: 'Tags',
        data() {
            return {
                form_modal: false,
                name: '',
                file: '',
                color: '',
                previewImage: '',
                description: '',
                selected_item: '',
                items_tags: items_tags.map((item, row_id) => {
                    return {...item, row_id}
                }),
                fields,

                details: [],
                collapseDuration: 0,
                status_form: 0
            }
        }, mounted() {
            this.get_data();
        },
        methods: {
            openEditModal(item) {
                this.editDetails(item);
                this.form_modal = true;
            },
            closeFormModal() {
                this.form_modal = false;
                this.name = '';
                this.selected_item = '';
                this.status_form = 0;
            },
            onFormModalToggle(show) {
                if (!show) {
                    this.name = '';
                    this.selected_item = '';
                    this.status_form = 0;
                }
            },
            editDetails(item) {

                    // this.$set(this.items[item.id], '_toggled', !item._toggled)
                    this.name = this.items_tags[item.row_id].name;
                    this.selected_item = item;

                    this.status_form = this.items_tags[item.row_id].id;
                    // this.$nextTick(() => {
                    //     this.collapseDuration = 0
                    // })

            }, get_data() {
                var self = this;
                // console.log("route id "+this.$route.params.cat_id);

                axios.get('/api/admin/product_tags', {}).then(function (response) {

                    var contents = response.data;

                    // items = content_cats.orders;

                    self.items_tags = contents.tags.map((item, row_id) => {
                        return {...item, row_id}
                    }),
                        fields;

                    // console.log("cats is " + self.items_active);
                    // self.description = '';
                    // localStorage.setItem("api_token", response.data.access_token);
                    // self.$router.push({ path: 'notes' });
                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            goRegister() {
                this.$router.push({path: 'register'});
            }, edit() {


                let self = this;
                // const formData = new FormData()
                let url;
                url = "/api/admin/product_tags";


                axios.post(  url, {
                    name: self.name,
                    // roles: self.$refs.permissions,
                    id: self.status_form,
                }).then(function (response) {

                    self.items_tags[self.selected_item.row_id].name=self.name;
                    self.selected_item = '';

                    self.name = '';
                    self.status_form=0;
                    self.form_modal = false;
                    self.$root.modal_component.show_api_response_modals(response);
                    // localStorage.setItem("api_token", response.data.access_token);
                    // self.$router.push({ path: 'notes' });
                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
        }
    }


</script>
